import { render, staticRenderFns } from "./DsfrNativeSelect.vue?vue&type=template&id=bece64a6&scoped=true&"
import script from "./DsfrNativeSelect.vue?vue&type=script&lang=js&"
export * from "./DsfrNativeSelect.vue?vue&type=script&lang=js&"
import style0 from "./DsfrNativeSelect.vue?vue&type=style&index=0&id=bece64a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bece64a6",
  null
  
)

export default component.exports